import { signInWithEmailAndPassword } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { ActionFunction, Form, Link, Navigate, json, redirect } from 'react-router-dom';

import { auth } from '../../firebase';

import Background from '../../components/layout/Background';
import Content from '../../components/layout/Content';
import Card from '../../components/ui/Card';

import Button from '../../components/ui/Button';
import classes from './Login.module.css';

import { useAppSelector } from '../../store/hooks';

const Login = () => {
  const loggedIn = useAppSelector(state => state.auth.loggedIn);
  const { t } = useTranslation();

  if (loggedIn) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <Content>
        <Card extraStyles={{ flex: 0.1 }} withMargin="bottom">
          <h1>{t('loginPage.title')}</h1>
        </Card>
        <Card extraStyles={{ justifyContent: 'flex-start', overflow: 'auto' }}>
          <Form method="POST" className={classes.form}>
            <label htmlFor="email">{t('loginPage.email')}</label>
            <input type="email" name="email" id="email" autoComplete="off" />
            <label htmlFor="password">{t('loginPage.password')}</label>
            <input type="password" name="password" id="password" autoComplete="off" />
            <Button type="submit">{t('loginPage.login')}</Button>
          </Form>
        </Card>
        <Card extraStyles={{ flex: 0.1 }} withMargin="top">
          <Link to="/">
            <Button>{t('buttons.back')}</Button>
          </Link>
        </Card>
      </Content>
      <Background />
    </>
  );
};

export const action: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const email = formData.get('email') as string;
  const password = formData.get('password') as string;
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (error) {
    throw json({ message: i18next.t('loginPage.failed') }, { status: 401 });
  }
  return redirect('/');
};

export default Login;
